export function feeForZone(pricing, zoneId) {
  const zone = (pricing?.zones || []).find((z) => z.id === zoneId);
  if (zone) {
    return { fee: Number(zone.price) || 0, zoneName: zone.name, isFallback: false };
  }
  return {
    fee: Number(pricing?.fallback_price) || 0,
    zoneName: "Tarif par défaut",
    isFallback: true,
  };
}
